export const APP_SHOW_MENU = 'APP_SHOW_MENU'
export const APP_SHOW_WIDTH = 'APP_SHOW_WIDTH'
export const ADMIN_LOGOUT_USER = 'ADMIN_LOGOUT_USER'
export const SET_LOP_HEADER = 'SET_LOP_HEADER'
export const SET_IS_AUTHENTICATED = 'SET_IS_AUTHENTICATED'
